import { Box, Paper, Typography, useTheme } from "@mui/material";
import type React from "react";
import { useState } from "react";
import SzLoading from "../../UISharedConstructors/Loading/SzLoading.tsx";

export const ThumbnailImage: React.FC<{ src: string; alt: string; index: number; onClick: () => void; isActive: boolean }> = ({
	src,
	alt,
	index,
	onClick,
	isActive,
}) => {
	const [loaded, setLoaded] = useState(false);
	const ppTheme = useTheme();

	const handleImageLoaded = () => {
		setLoaded(true);
	};
	return (
		<Box
      // adding this to img tags doesn't work on eVyveska (has Firefox)
      onTouchStart={() => {
        console.info("TOUCH START!"); // TODO: remove after eVyveska tested
        onClick();
      }}
      // it doesn't matter where onlick is on regular browsers
      onClick={() => {
        console.info("CLICK!"); // TODO: remove after eVyveska tested
        onClick();
      }}
      sx={{ display: "flex", flexDirection: "column", alignItems: "center", cursor: "pointer", p: 1 }}
    >
			{!loaded && (
				<Paper
					sx={{
						width: 90,
						height: 60,
						m: 0.5,
						opacity: isActive ? 1 : 0.5,
						border: isActive ? `2px solid ${ppTheme.palette.info.main}` : "none",
						cursor: "pointer",
						"&:hover": {
							opacity: 0.75,
						},
					}}
				>
					<SzLoading logoVariant="text" sizeVariant={2} colorVariant="mix" mildCircle={true} mildLogo={true} />
				</Paper>
			)}
			<Paper
				component="img"
				src={src}
				alt={alt}
				onLoad={handleImageLoaded}
				sx={{
					width: 90,
					height: 60,
					m: 0.5,
					opacity: loaded ? (isActive ? 1 : 0.5) : 0,
					border: isActive ? `2px solid ${ppTheme.palette.info.main}` : "none",
					cursor: "pointer",
					"&:hover": {
						opacity: 0.75,
					},
				}}
				style={{ display: loaded ? "block" : "none" }} // Only display image when loaded
			/>
			<Typography variant="caption" sx={{ color: "text.primary" }}>
				{index + 1}
			</Typography>
		</Box>
	);
};
